<template>
    <div class="elder-family">
        <mt-header fixed title="家庭信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-field label="联系人姓名" placeholder="请输入联系人姓名" v-model="first_people_name"></mt-field>
            <mt-field label="联系人电话" type="number" placeholder="请输入联系人电话" v-model="first_people_phone"></mt-field>
            <mt-radio title="与联系人关系" v-model="first_people_relation" :options="firstPeopleRelationOptions"></mt-radio>

            <mt-field label="子女数量" placeholder="请输入子女数量" v-model="children_count"></mt-field>
            <mt-cell
                    title="子女信息"
                    is-link
                    :to="'/elder/family/children/'+id"
                    >
                点击设置子女信息
            </mt-cell>

            <mt-checklist title="养老方式" v-model="live_way" :options="liveWayOptions"></mt-checklist>
            <mt-checklist title="燃料类型" v-model="gas_type" :options="gasTypeOptions"></mt-checklist>
            <mt-checklist title="饮水类型" v-model="water_type" :options="waterTypeOptions"></mt-checklist>
            <mt-checklist title="厨房排风类型" v-model="kitchen_type" :options="kitchenTypeOptions"></mt-checklist>
            <mt-checklist title="宠物" v-model="cats_type" :options="catsTypeOptions"></mt-checklist>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    export default{


        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,

                first_people_name:'',
                first_people_phone:'',
                first_people_relation:'',
                children_count:'',
                firstPeopleRelationOptions:[],

                live_way:[],
                liveWayOptions:[],

                gas_type:[],
                gasTypeOptions:[],

                water_type:[],
                waterTypeOptions:[],

                kitchen_type:[],
                kitchenTypeOptions:[],

                cats_type:[],
                catsTypeOptions:[]

            }
        },

        methods:{
            //mini-select
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/family", {openid:this.openid,elder:this.id,first_people_name:this.first_people_name,first_people_phone:this.first_people_phone,first_people_relation:this.first_people_relation,live_way:this.live_way,gas_type:this.gas_type,water_type:this.water_type,kitchen_type:this.kitchen_type,cats_type:this.cats_type,children_count:this.children_count,is_children:0})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {

                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){
            this.$axios.get('/elder/family?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        var first_people_relation_array = Array();
                        for(let i=0;i<data.data.options.first_people_relation.length;i++){
                            first_people_relation_array[i] = { label:data.data.options.first_people_relation[i],value:data.data.options.first_people_relation[i]};
                        }
                        this.firstPeopleRelationOptions = first_people_relation_array;


                        var live_way_array = Array();
                        for(let i=0;i<data.data.options.live_way.length;i++){
                            live_way_array[i] = { label:data.data.options.live_way[i],value:data.data.options.live_way[i]};
                        }
                        this.liveWayOptions = live_way_array;

                        var gas_type_array = Array();
                        for(let i=0;i<data.data.options.gas_type.length;i++){
                            gas_type_array[i] = { label:data.data.options.gas_type[i],value:data.data.options.gas_type[i]};
                        }
                        this.gasTypeOptions = gas_type_array;

                        var water_type_array = Array();
                        for(let i=0;i<data.data.options.water_type.length;i++){
                            water_type_array[i] = { label:data.data.options.water_type[i],value:data.data.options.water_type[i]};
                        }
                        this.waterTypeOptions = water_type_array;

                        var kitchen_type_array = Array();
                        for(let i=0;i<data.data.options.kitchen_type.length;i++){
                            kitchen_type_array[i] = { label:data.data.options.kitchen_type[i],value:data.data.options.kitchen_type[i]};
                        }
                        this.kitchenTypeOptions = kitchen_type_array;

                        var cats_type_array = Array();
                        for(let i=0;i<data.data.options.cats_type.length;i++){
                            cats_type_array[i] = { label:data.data.options.cats_type[i],value:data.data.options.cats_type[i]};
                        }
                        this.catsTypeOptions = cats_type_array;

                        let family_info = data.data.data;
                        if(family_info!==null){
                            this.first_people_name = family_info.first_people_name;
                            this.first_people_phone = family_info.first_people_phone;
                            this.first_people_relation = family_info.first_people_relation;
                            this.children_count = family_info.children_count;

                            this.live_way = family_info.live_way===null?[]:family_info.live_way.split(',');
                            this.gas_type = family_info.gas_type===null?[]:family_info.gas_type.split(',');
                            this.water_type = family_info.water_type===null?[]:family_info.water_type.split(',');
                            this.kitchen_type = family_info.kitchen_type===null?[]:family_info.kitchen_type.split(',');
                            this.cats_type = family_info.cats_type===null?[]:family_info.cats_type.split(',');
                        }


                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }


    }
</script>


// WEBPACK FOOTER //
// src/pages/elder/family.vue